if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        //this.initCustomSizeOptionHandlers();
        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

//     initCustomSizeOptionHandlers() { 
//       const customSizeOptions = this.querySelectorAll('.custom_size_option');
//       if (!customSizeOptions.length) return;
    
//       customSizeOptions.forEach(option => {
//         option.addEventListener('click', (event) => {
//           // Remove 'active' from all options
//           customSizeOptions.forEach(opt => opt.classList.remove('active'));
    
//           // Add 'active' to clicked option
//           event.currentTarget.classList.add('active');
    
//           // Get the clicked value
//           const value = event.currentTarget.getAttribute('data-value');
    
//           // Set hidden input value (assuming it is inside this custom element)
//           const hiddenInput = this.querySelector('#custom_size_value');
//           if (hiddenInput) hiddenInput.value = value;
    
//           // If you want, call any class method or trigger custom logic here
//           console.log('Custom size selected:', value);

//           //const currentUrl = window.location.href;
//           //this.handleUpdateProductInfo('/products/old-fashioned-landscape');
    
//           // Optional: dispatch an event so other components can react
//           this.dispatchEvent(new CustomEvent('custom-size-changed', {
//             detail: { value },
//             bubbles: true,
//             composed: true,
//           }));
//         });
//       });
// }

      
      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
       // console.log(productUrl);
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } 
            else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      updateBuyButton(html) {

       // console.log(html);
        const variantSelects = html.querySelector(".product-form__buttons");
       // console.log(variantSelects);
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantBuyButtonSelector,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
        const variant = this.getSelectedVariant(html);
        //console.log(html, 'html');
        const priceElement = document.querySelector('.add-to-cart-regular-price');
        
        setTimeout(() => {
          const priceElement = document.querySelector('.add-to-cart-regular-price');
        
          if (priceElement && variant?.price != null) {
            const variantAmount = (variant.price / 100).toFixed(2);
            let formatVariantPrice = variantAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const currencySymbol = priceElement.getAttribute('data-currency') || '';
            const variantPrice = `${currencySymbol}. ${formatVariantPrice}`;
            priceElement.classList.add('hidden');
        
            if (priceElement.textContent.trim() !== variantPrice) {
              priceElement.textContent = formatVariantPrice;
            }
        
            requestAnimationFrame(() => {
              priceElement.classList.remove('hidden');
            });
          }
        }, 100);




        var NewHTML = html;
        //console.log(NewHTML, 'NewHTML');  
        const layoutEl = document.getElementById("custom_border_layout");
        const layoutElParent = layoutEl?.parentElement;
        const imagesAlt = document.querySelectorAll(".frame_images");
        const allImages = document.querySelectorAll(".custom_frame_images");
        
        allImages.forEach(img => img.style.display = "none");
        layoutElParent.classList.remove("passepartout", "canvas", "print", "unframe");
        document.body.classList.remove("canvas", "print", "show_unframe_main");

        console.log('variant value:', variant);
        console.log(typeof variant);
        if(variant === null)
        {
          setTimeout(() => {
            const $inputSelect = $('input[data-option-value-id="6043250098357"]');
              if ($inputSelect.length && !$inputSelect.is(':checked')) {
              $inputSelect.trigger('click');
            }    
          }, 300);      
        }
        
        const variant_handle = variant.option1.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const color_handle = variant.option2.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          //console.log('herer '+ color_handle,variant_handle);
        const VariantSize = variant.option3.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        
        const sizeToMaxWidth = {
        '45x30': { desktop: 183, mobile: 90 },
        '60x40': { desktop: 252, mobile: 124 },
        '75x50': { desktop: 295, mobile: 146 },
        '90x60': { desktop: 351, mobile: 174 },
        '105x70': { desktop: 415, mobile: 206 },
        '30x40': { desktop: 133, mobile: 65 },
        '45x60': { desktop: 183, mobile: 90 },
        '55x75': { desktop: 215, mobile: 106 },
        '65x90': { desktop: 252, mobile: 124 },
        '75x105': { desktop: 295, mobile: 146 },
        '100x140': { desktop: 330, mobile: 166 },
        '120x160': { desktop: 365, mobile: 186 },
        '150x200': { desktop: 400, mobile: 206 },
        '30x30': { desktop: 183, mobile: 90 },
        '45x45': { desktop: 252, mobile: 124 },
        '60x60': { desktop: 295, mobile: 146 },
        '80x80': { desktop: 351, mobile: 174 },
        '100x100': { desktop: 415, mobile: 206 }        
        };
        const isMobile = window.innerWidth <= 768;
        const maxWidth = sizeToMaxWidth[VariantSize]?.[isMobile ? 'mobile' : 'desktop'];
        if (maxWidth) {
          document.querySelectorAll('#custom_wall-frame_layout .image_size_changed').forEach(img => {
            img.style.maxWidth = `${maxWidth}px`;
          });
        }
        //console.log(variant_handle, '-----------------');


        if (variant_handle === 'print') {
          $('input[type="radio"][value="150x200"]').addClass('hide_size_variant');
        } else {
          $('input[type="radio"][value="150x200"]').removeClass('hide_size_variant');
        }

        let passepartoutValue = 'no';
        if (variant_handle === 'canvas') {
        const defaultOption = document.querySelector('.custom_size_option[data-value="no"]');
        if (defaultOption) defaultOption.click();
        } else {
        const activeOption = document.querySelector('.custom_size_option.active');
        passepartoutValue = activeOption?.getAttribute('data-value') || 'no';
        }
        
        const customSizeOptions = document.querySelectorAll('.custom-size-options');
        customSizeOptions.forEach(el => {
        el.style.display = (variant_handle === "canvas" || color_handle === "unframe") ? "none" : "block";
        });
        
        const VarianthandleCustom = `framed-${variant_handle}-${color_handle}`;
        
        if (variant_handle === "print" && passepartoutValue === "no") {
        document.querySelectorAll(".print_frame_images").forEach(img => img.style.display = "block");
        } else if (variant_handle === "canvas" && passepartoutValue === "no") {
        document.querySelectorAll(".canvas_frame_images").forEach(img => img.style.display = "block");
        } else if (variant_handle === "print" && passepartoutValue === "yes") {
        document.querySelectorAll(".passepartout_frame_images").forEach(img => img.style.display = "block");
        }
        
        const imageAltTarget = passepartoutValue === 'yes'
        ? `${VarianthandleCustom}-passepartout`
        : VarianthandleCustom;
        
        window.requestAnimationFrame(() => {
        if (passepartoutValue === 'yes') {
          layoutElParent.classList.add("passepartout");
        } else {
          const title = variant.title.toLowerCase();
          console.log(title);
          console.log(layoutElParent);
          if (title.includes('canvas')) {
            layoutElParent.classList.add("canvas");
            document.body.classList.add("canvas");
          }
          if (title.includes('print')) {
            layoutElParent.classList.add("print");
            document.body.classList.add("print");
          }
          if (title.includes('unframe')) {
            layoutElParent.classList.add("unframe");
            document.body.classList.add("show_unframe_main");
          }          
        }
        
        imagesAlt.forEach((img) => {
          const altText = img.getAttribute('alt');
          const match = altText === imageAltTarget;
          console.log(imageAltTarget, altText)
          img.classList.toggle('show', match);
          img.classList.toggle('hide', !match);
        });
        });
        
        // ✅ Dynamic price formatting
        const currencySymbol = window.Shopify?.currency?.symbol || 'Dhs.';
        const regular_price = (variant.price / 100).toFixed(2);
        const compare_price = (variant.compare_at_price / 100)?.toFixed(2);
        const formattedComparePrice = compare_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const formattedRegularPrice = regular_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        console.log(formattedComparePrice,formattedRegularPrice);
        const addToCartRegular = document.querySelector(".add-to-cart-regular-price");
        const displayRegularPrice = document.querySelector(".price__regular .price-item--regular");
        const displaySaleRegularPrice = document.querySelector(".price__sale .price-item--regular");
        const addToCartCompare = document.querySelector(".add-to-cart-compare-price");
        const displayComparePrice = document.querySelector(".price-item--sale");
        //const displaySaleBadge = document.querySelector(".custom-badge"); 
        //console.log(displaySaleBadge, displaySaleRegularPrice);
        if (addToCartRegular) {
          addToCartRegular.textContent = `${currencySymbol} ${formattedRegularPrice}`;
        }          
        if (displayRegularPrice) {
          displayRegularPrice.textContent = `${currencySymbol} ${formattedRegularPrice}`;
        }
        if (displayComparePrice) {
            displayComparePrice.textContent = `${currencySymbol} ${formattedRegularPrice}`;
          } 
          // if (compare_price && compare_price > regular_price) 
          //   {
          //     console.log('welcome compare price');
          //     if(displaySaleRegularPrice){
          //       displaySaleRegularPrice.style.display='inline-block';
          //       displaySaleRegularPrice.textContent = `${currencySymbol} ${compare_price}`;
          //     }
          //     if(displayComparePrice){
          //       displayComparePrice.classList.remove('custom_price_color');
          //     }
          //   //displaySaleBadge.style.display='inline-block';
          // } else {
          //     if(displayComparePrice){
          //       displayComparePrice.classList.add('custom_price_color');
          //     }
          //    //displaySaleBadge.style.display='none';
          //    if(displaySaleRegularPrice) {
          //     displaySaleRegularPrice.style.display='none';
          //    } 
          // }  
          const comparePriceNum = parseFloat(compare_price);
        const regularPriceNum = parseFloat(regular_price);

        if (!isNaN(comparePriceNum) && comparePriceNum > regularPriceNum) {
         // console.log('welcome compare price');
          if (displaySaleRegularPrice) {
            displaySaleRegularPrice.style.display = 'inline-block';
            displaySaleRegularPrice.textContent = `${currencySymbol} ${formattedComparePrice}`;
          }
          if (displayComparePrice) {
            displayComparePrice.classList.remove('custom_price_color');
          }
          let elementsToHide = document.querySelectorAll('.variant_disocunt_badge');
            elementsToHide.forEach(element => {
              element.style.display = 'none';
            });
            document.getElementById('variant_'+variant.id).style.display='block';
        } else {
          //console.log('else');
          if (displayComparePrice) {
            displayComparePrice.classList.add('custom_price_color');
          }
          if (displaySaleRegularPrice) {
            displaySaleRegularPrice.style.display = 'none';
          }
          let elementsToHide = document.querySelectorAll('.variant_disocunt_badge');
            elementsToHide.forEach(element => {
              element.style.display = 'none';
            });
        } 
          
           if (addToCartCompare) {
            addToCartCompare.textContent = `${currencySymbol} ${compare_price}`;
          }       
        // requestIdleCallback(() => {
        // if (addToCartRegular) {
        //   addToCartRegular.textContent = `${currencySymbol} ${regular_price}`;
        // }
        // if (displayRegularPrice) {
        //   displayRegularPrice.textContent = `${currencySymbol} ${regular_price}`;
        // }
        
        // if (compare_price && compare_price > regular_price) {
        //   if (addToCartCompare) {
        //     addToCartCompare.textContent = `${currencySymbol} ${compare_price}`;
        //   }
        //   if (displayComparePrice) {
        //     displayComparePrice.textContent = `${currencySymbol} ${regular_price}`;
        //   }
        // }
        // });
        
        this.pickupAvailability?.update(variant);
        this.updateBuyButton(html);
        this.updateURL(productUrl, variant.id);
        this.updateVariantInputs(variant.id);
        this.updateMedia(html, variant?.featured_media?.id);
        
        const updateSourceFromDestination = (id, shouldHide = () => false) => {
        const source = html.getElementById(`${id}-${this.sectionId}`);
        const destination = this.querySelector(`#${id}-${this.dataset.section}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.toggle("hidden", shouldHide(source));
        }
        };
        
        updateSourceFromDestination("price");
        updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));
        updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");
        updateSourceFromDestination("Volume");
        updateSourceFromDestination("Price-Per-Item", ({ classList }) => classList.contains("hidden"));
        
        this.updateQuantityRules(this.sectionId, html);
        this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove("hidden");
        this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove("hidden");
        
        this.productForm?.toggleSubmitButton(
        html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute("disabled") ?? true,
        window.variantStrings.soldOut,
        variant
        );
        
        publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.sectionId,
          html,
          variant,
        },
        });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        //alert(url, variantId);
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }
      
      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            //console.log(response,"html");
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get variantBuyButtonSelector() {
        return this.querySelector(".product-form__buttons");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


const activeSlide = document.querySelector('.swiper-slide input:checked').parentNode;
const activeIndex = activeSlide ? Array.from(activeSlide.parentNode.children).indexOf(activeSlide) : 0;
const swatchSlider = new Swiper(".swiper-container-variant-picker", {
  slidesPerView: 4, 
  spaceBetween: 3,
  autoplay: false,
  //centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: false,
  slideToClickedSlide: true,
  speed: 1000,
  shortSwipes: true,
  breakpoints: {
    768: {
      slidesPerView: 4,
    },
    480: {
      perView: 4
    }
  },
  initialSlide: activeIndex
});

document.addEventListener("DOMContentLoaded", function () {
  const regularPriceEl = document.querySelector("[data-regular_price]");
  const comparePriceEl = document.querySelector("[data-compare_price]");

  // Update regular price if available
  if (regularPriceEl) {
    const variantPrice = regularPriceEl.getAttribute("data-regular_price");
    let formatVariantPrice = variantPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //console.log('welcome', formatVariantPrice);
    const displayRegular = document.querySelector(".add-to-cart-regular-price");
    if (displayRegular) {
      displayRegular.textContent = " " + formatVariantPrice;
    }
  }

  // Update compare price only if available
  if (comparePriceEl) {
    const comparePrice = comparePriceEl.getAttribute("data-compare_price");
    const displayCompare = document.querySelector(".add-to-cart-compare-price");
    if (displayCompare) {
      displayCompare.textContent = " " + comparePrice;
    }
  }
});
